import { DistanceUnit } from '@common/enums/configuration/units';
import { Language } from '../enums/languages';
import OrganizationRole from '../enums/organization-roles';
import UserRole from '../enums/user-roles';
import {
  defaultListOrganizationState,
  mockListManufacturer,
} from '../organization/list-organization';
import Acceptance from './agreements/acceptance';
import User from './user';
import LoginVariant from '../enums/login-variant';

export interface RobotSubscriptions {
  id: string;
  name: string;
  organizationName: string;
}

export interface SupportContact {
  phoneNumber: string | null;
  email: string | null;
  name: string;
}

export interface OrganizationSubscriptions {
  id: string;
  name: string;
  role: OrganizationRole;
  locations: OrganizationSubscriptions[];
  robots: RobotSubscriptions[];
}

interface CurrentUser extends User {
  agreementAcceptances: Acceptance[];
  robotSubscriptions: RobotSubscriptions[];
  organizationSubscriptions: OrganizationSubscriptions[];
  hasWireguardAccess: boolean;
  support: SupportContact;
  isTwoFactorEnabled: boolean;
  isTwoFactorConfigured: boolean;
  lastLoginVariant: LoginVariant;
}

export const defaultUserState = {
  // check in app settings that id length of logged in user is > 0 else stuck to login page
  id: '',
  name: '',
  email: '',
  phoneNumber: '',
  dateCreated: '',
  role: UserRole.MEMBER,
  organization: defaultListOrganizationState,
  agreementAcceptances: [],
  language: Language.ENGLISH,
  distanceUnit: DistanceUnit.METRIC,
  robotSubscriptions: [],
  organizationSubscriptions: [],
  hasWireguardAccess: false,
  isTwoFactorEnabled: false,
  isTwoFactorConfigured: false,
  lastLoginVariant: LoginVariant.Local,
  support: {
    email: null,
    phoneNumber: null,
    name: 'KEMARO',
  },
} as CurrentUser;

export default CurrentUser;

// mock data

export const mockCurrentUser = {
  id: '9aca2f49-9bfe-4e3f-a4e0-d45c72a9d085',
  name: 'John Snow',
  dateCreated: '2024-07-26T12:54:13',
  email: 'someEmail@example.ch',
  phoneNumber: null,
  role: UserRole.ADMIN,
  distanceUnit: DistanceUnit.METRIC,
  agreementAcceptances: [],
  organization: {
    id: mockListManufacturer.id,
    name: 'Kemaro',
    role: OrganizationRole.MANUFACTURER,
    robotCount: 4,
    parentId: null,
    parentName: null,
    userCount: 2,
    subOrganizationCount: 1,
    require2fa: false,
    enforceSSO: false,
    skipThirdPartyTwoFa: false,
  },
  robotSubscriptions: [],
  organizationSubscriptions: [],
  language: Language.ENGLISH,
  hasWireguardAccess: false,
  isTwoFactorEnabled: false,
  isTwoFactorConfigured: false,
  lastLoginVariant: LoginVariant.Local,
  support: {
    email: 'support@kemaro.ch',
    phoneNumber: '1234',
    name: 'KEMARO',
  },
} as CurrentUser;

export const mockCurrentUser2 = {
  id: '9aca2f49-9bfe-4e3f-a4e0-d45c72a9d053',
  name: 'Jane Doe',
  dateCreated: '2024-07-26T12:54:13',
  email: 'jane@example.ch',
  distanceUnit: DistanceUnit.METRIC,
  phoneNumber: null,
  role: UserRole.MEMBER,
  agreementAcceptances: [],
  organization: {
    id: mockListManufacturer.id,
    name: 'Kemaro',
    role: OrganizationRole.MANUFACTURER,
    robotCount: 4,
    parentId: null,
    parentName: null,
    userCount: 2,
    subOrganizationCount: 1,
    require2fa: false,
    enforceSSO: false,
    skipThirdPartyTwoFa: false,
  },
  language: Language.ENGLISH,
  robotSubscriptions: [],
  organizationSubscriptions: [],
  hasWireguardAccess: false,
  isTwoFactorEnabled: false,
  isTwoFactorConfigured: false,
  lastLoginVariant: LoginVariant.Local,
  support: {
    email: 'support@kemaro.ch',
    phoneNumber: '1234',
    name: 'KEMARO',
  },
} as CurrentUser;
